<template>
    <el-row class="headsyl">
      <el-col :span="2">
        <div>
          <span class="bannerfont">广告位</span>
        </div>
      </el-col>
      <el-col :span="22">
        <div>
          <span :class="[ this.tabName == '1' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('1')">活动</span>
          <span :class="[ this.tabName == '2' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('2')">投放</span>
          <!-- <span :class="[ this.tabName == '3' ? 'clickcolor headerfont' : 'headerfont',]" @click="tabChange('3')" >流量统计</span> -->
        </div>
      </el-col>
    </el-row>
  </template>
  
  <script>
  export default {
    name: "BannerHeader",
    data() {
      return {
        tabName: "1",
      };
    },
    methods: {
      tabChange(tab) {
        this.tabName = tab;
        this.$emit("childByValue", this.tabName);
      },
    },
  };
  </script>
  
  <style scoped>
  .headsyl {
    background-color: white;
    margin: 10px 20px;
    display: flex;
    align-items: center;
  }
  .bannerfont {
    font-size: 1.6rem;
    margin-left: 2rem;
  }
  .clickcolor {
    background-color: rgb(253 237 216);
  }
  
  .headerfont {
    font-size: 1.4rem;
    width: 9%;
    display: inline-block;
    margin: 1rem 1rem 1rem 0;
    text-align: center;
  }
  
  .headerfont:hover {
    background-color: rgb(253 237 216);
    cursor: pointer;
  }
  </style>
  